export default function (type, ...argNames) {
  return (...args) => {
    const action = { type };
    argNames.forEach((arg, index) => {
      action[argNames[index]] = args[index];
    });
    return action;
  };
}



// WEBPACK FOOTER //
// ./app/scripts/utils/make-action-creator.js